const $ = require('jquery');

jQuery(document).ready(function () {


    $('.booking-form').each(function () {
        var $this = $(this);
        var $arrival = $this.find('.arrival-date');
        var $departure = $this.find('.departure-date');

        var start = $this.data('start') || moment().format('YYYYMMDD');
        var min_date = $this.data('min-date') || moment().format('YYYYMMDD');

        var arrival = moment(start, 'YYYYMMDD');
        var has_nights = ($this.data('nights') > 0);
        var nights = (has_nights) ? $this.data('nights') : 1;
        var departure = arrival.clone().add(nights, 'days');

        var startDate,
            endDate,
            updateStartDate = function (start_date) {
                startDate = start_date;
                endDate = endPicker.getDate();

                if (has_nights) {
                    var end = new Date(startDate.getTime() + (nights * (24 * 60 * 60 * 1000)));

                    endPicker.setMinDate(end);
                    endPicker.setMaxDate(end);

                    endPicker.setDate(end);
                    endPicker.setStartRange(startDate);
                    endPicker.setEndRange(end);

                }
                else {
                    if (startDate > endDate) {
                        endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
                        endPicker.setDate(endDate);
                        endPicker.setStartRange(startDate);
                        endPicker.setMinDate(startDate);
                    }
                }

                startPicker.setStartRange(startDate);
                startPicker.setEndRange(endDate);
            },
            updateEndDate = function (end_date) {
                endDate = end_date;

                startPicker.setEndRange(endDate);
                endPicker.setEndRange(endDate);
            },
            startField = $(this).find('input[name=arrive]')[0],
            startPicker = new Pikaday({
                format: 'DD/MM/YYYY',
                field: startField,
                firstDay: 1,
                minDate: moment(min_date, 'YYYYMMDD').toDate(),
                defaultDate: arrival.toDate(),
                setDefaultDate: true,
                i18n: pikaday_i18n,
                onSelect: function () {
                    updateStartDate(this.getDate());
                    endPicker.show();
                }
            }),
            endField = $(this).find('input[name=depart]')[0],
            endPicker = new Pikaday({
                format: 'DD/MM/YYYY',
                field: endField,
                firstDay: 1,
                minDate: new Date(),
                defaultDate: departure.toDate(),
                setDefaultDate: true,
                i18n: pikaday_i18n,
                onSelect: function () {
                    updateEndDate(this.getDate());
                }
            });

        updateStartDate(arrival.toDate());
    });

});
